<template>
    <div class="card">
        <div class="card-body" v-if="chartOptions">
            <p class="chart-title">Produto por Formato</p>
            <apexcharts type="heatmap" height="550" :options="chartOptions" :series="chartSeries" />
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
    components: { apexcharts: VueApexCharts },
    props: {
        tabela: {
            type: Object,
            required: true
        }
    },
    computed: {
        // ...todos os computed acima...
        produtos() {
            const map = new Map();
            Object.values(this.tabela).forEach(formatos => {
                Object.values(formatos).forEach(info => {
                    if (!map.has(info.produto_name)) map.set(info.produto_name, true);
                });
            });
            return Array.from(map.keys());
        },
        formatos() {
            const map = new Map();
            Object.values(this.tabela).forEach(formatos => {
                Object.values(formatos).forEach(info => {
                    if (!map.has(info.formato_name)) map.set(info.formato_name, true);
                });
            });
            return Array.from(map.keys());
        },
        chartSeries() {
            return this.formatos.map(formato => ({
                name: formato,
                data: this.produtos.map(produto => {
                    let qtd = null;
                    for (const produtoId in this.tabela) {
                        const formatosTb = this.tabela[produtoId];
                        for (const formatoId in formatosTb) {
                            const info = formatosTb[formatoId];
                            if (info.produto_name === produto && info.formato_name === formato) {
                                qtd = info.quantidade;
                                break;
                            }
                        }
                    }
                    return qtd || 0;
                })
            }));
        },
        chartOptions() {
            return {
                chart: {
                    type: "heatmap",
                    toolbar: { show: false }
                },
                dataLabels: { enabled: true },
                xaxis: {
                    categories: this.produtos
                },
                yaxis: {
                    title: { text: 'Formatos' }
                },
                colors: ["#008FFB"]
            };
        }
    }
}
</script>
<style>
.apexcharts-canvas {
    margin: 0 auto !important;
}
</style>
